export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f54fa30dab7a666ec6b9f4a3ba093f85ff161624a&name=fetchTypeahead!'